import { useMutateEntry, makeInitialOpgavekompleksetTaskEntry } from '@utils/component-framework';
import { useOpgavekompleksetComponent } from '../context.data.js';

function useGoToTaskMutation() {
  const {
    entryKey,
    data
  } = useOpgavekompleksetComponent();
  const mutater = useMutateEntry(entryKey);
  return taskId => mutater(entry => {
    const activeTaskId = entry.data.activeTaskId ?? data.tasks[0]?.id;
    if (!activeTaskId) {
      return entry;
    }
    const currentTask = entry.data.tasks[activeTaskId] ??= makeInitialOpgavekompleksetTaskEntry(data, activeTaskId);
    currentTask.state.closed = true;
    currentTask.state.skipped = false;
    entry.data.activeTaskId = taskId;
    return entry;
  });
}

export { useGoToTaskMutation };
//# sourceMappingURL=task.go-to.js.map
